export enum ENTETE_TABLEAU_LISTE_CNC_ENUM {
	compte = 'Compte',
	tencode = 'TenCode',
	codeposte = 'CodePoste'
}